import png from "./png";

export default {
  png
};



// WEBPACK FOOTER //
// ./src/assets/brands/index.js